// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import Es6Promise from 'es6-promise'
import App from './App'
import store from './store'
import axios from 'axios'
import VueWechatTitle from 'vue-wechat-title'
import noNet from './components/emptypage/noNet/index'
import connectionFail from './components/emptypage/connectionFail/index'
import {
  ActionSheet,
  AddressList,
  Button,
  Cell,
  CellGroup,
  Checkbox,
  CheckboxGroup,
  Col,
  CountDown,
  DatetimePicker,
  Dialog,
  Field,
  Icon,
  Lazyload,
  List,
  PullRefresh,
  Radio,
  RadioGroup,
  Rate,
  Row,
  Search,
  Stepper,
  Toast,
  TreeSelect,
  Uploader,
  Badge,
  Sidebar,
  SidebarItem
} from 'vant'
import AwesomePicker from 'vue-awesome-picker'
import 'vant/lib/index.css'
import waptoken from './assets/common/js/wapid'
import router from './router'
import {
  basepath,
  wxConfig,
  buriedPoint,
  commonburiedPoint,
  identity,
  getlinkidFn,
  clickburiedPoint,
  isWeixin,
  ckeckgraphic,
  getVipLevel,
  checkAgent,
  newuserFn,
  errorHeadImgFunc
} from './assets/common/js/config'
import { customRequestAjax } from '@/axiosApi'
import ajax from './axiosApi/ajax_config'
import app from './assets/common/js/app_interactive'
require('es6-promise').polyfill()
Es6Promise.polyfill()
axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded' // post数据请求
// Vue.prototype.path = 'https://testofflineckysmall.ckc8.com/'
Vue.prototype.appkey = 'z3v5yqkbvsfv0'
Vue.prototype.ossUrl = 'https://ckysmall.ckc8.com/Wxmall/Sysinfo/getOssWeb' // OSS
Vue.prototype.staticImgUrl = 'https://ckysrestatic.ckc8.com/' // 图片地址
Vue.prototype.ossImgUrl = 'https://staicpcifile.oss-cn-shanghai.aliyuncs.com/' // 图片地址
Vue.prototype.$axios = axios
Vue.prototype.waptoken = waptoken
Vue.prototype.$customRequestAjax = customRequestAjax
Vue.prototype.$buriedPoint = buriedPoint
Vue.prototype.$identity = identity
Vue.prototype.$commonburiedPoint = commonburiedPoint
Vue.prototype.$clickburiedPoint = clickburiedPoint
Vue.prototype.$ckeckgraphic = ckeckgraphic
Vue.prototype.$getVipLevel = getVipLevel
Vue.prototype.$newuserFn = newuserFn
Vue.prototype.$ajax = ajax
Vue.prototype.$app = app
Vue.prototype.$errorHeadImgFunc = errorHeadImgFunc

Vue.use(VueWechatTitle)
Vue.use(noNet) // 啊哦，网络不太顺畅哦～
Vue.use(connectionFail) // 啊哦，服务器连接失败～
Vue.use(AwesomePicker)
Vue.use(Lazyload, {
  preLoad: 1,
  error: require('./assets/images/nopropic.png'),
  loading: require('./assets/images/nopropic.png'),
  attempt: 1
})
  .use(Row)
  .use(Col)
  .use(Icon)
  .use(Field)
  .use(Button)
  .use(Cell)
  .use(CellGroup)
  .use(Toast)
  .use(Dialog)
  .use(Stepper)
  .use(ActionSheet)
  .use(RadioGroup)
  .use(Radio)
  .use(TreeSelect)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Rate)
  .use(Uploader)
  .use(AddressList)
  .use(Search)
  .use(List)
  .use(CountDown)
  .use(PullRefresh)
  .use(DatetimePicker)
  .use(Badge)
  .use(Sidebar)
  .use(SidebarItem)

Vue.prototype.pagesize = 10
Vue.prototype.errorHeadImg = require('./assets/images/errorheadimg.png')
Vue.prototype.errorImg = require('./assets/images/nopropic.png')
Vue.config.productionTip = false

const agent = navigator.userAgent
const isiOS = !!agent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端

router.beforeEach((to, from, next) => {
  if (!sessionStorage.getItem('initLink')) {
    sessionStorage.setItem('initLink', document.URL)
  }
  let _url = window.location.origin + to.fullPath
  if (isWeixin()) {
    if (!isiOS) {
      setTimeout(() => {
        wxConfig(_url)
      }, 400)
    } else {
      let _url = ''
      if (
        !sessionStorage.getItem('location_href') ||
        (from.path == '/' && !from.name)
      ) {
        sessionStorage.setItem(
          'location_href',
          window.location.href.split('#')[0]
        )
        _url = window.location.href.split('#')[0]
      } else {
        _url = sessionStorage.getItem('location_href')
      }
      setTimeout(() => {
        wxConfig(_url)
      }, 400)
    }
  }
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    window.document.title = to.meta.title
  }
  if (from.name != null) {
    sessionStorage.setItem(
      'routefrom',
      JSON.stringify({ title: from.meta.title, link: basepath + from.fullPath })
    )
  }

  if (
    to.path != '/communitytopic' &&
    to.path != '/crosssellproducts' &&
    to.path == '/communityevaluation' &&
    from.path != '/communitytopic' &&
    from.path != '/crosssellproducts' &&
    from.name != null &&
    from.path != '/applyrecord'
  ) {
    // console.log('beforeEach', store.state.chooseTopic, store.state.chooseCrossSellProductItem)
    store.commit('CHOOSE_CROSS_SELL_PRODUCT_ITEM', null)
    store.commit('CHOOSE_TOPIC', null)
  }
  next()
})

try {
  if (checkAgent() == 'ios' || checkAgent() == 'pc') {
    window.addEventListener('pagehide', (event) => {
      sessionStorage.setItem(
        'window_scrolltop',
        event.target.children[0].scrollTop
      )
      sessionStorage.setItem(
        'routefrom',
        JSON.stringify({
          title: window.document.title,
          link: window.location.href
        })
      )
    })
  } else {
    document.addEventListener('pagehide', (event) => {
      sessionStorage.setItem(
        'window_scrolltop',
        event.target.children[0].scrollTop
      )
      sessionStorage.setItem(
        'routefrom',
        JSON.stringify({
          title: window.document.title,
          link: window.location.href
        })
      )
    })
  }
  window.onbeforeunload = function (event) {
    sessionStorage.setItem(
      'window_scrolltop',
      event.target.children[0].scrollTop
    )
    sessionStorage.setItem(
      'routefrom',
      JSON.stringify({
        title: window.document.title,
        link: window.location.href
      })
    )
  }
} catch (e) {
  console.log(e)
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>',
  watch: {
    $route(n) {
      let data = {}
      if (sessionStorage.getItem('routefrom')) {
        let routefrom = JSON.parse(sessionStorage.getItem('routefrom'))
        data.scenepoint = routefrom.title
        data.scenedesc = routefrom.link
      } else if (n.query.scenepoint) {
        data.scenepoint = decodeURIComponent(n.query.scenepoint)
      }
      this.$commonburiedPoint({
        data: data
      })
    }
  },
  beforeMount: function () {
    if (this.$route.query.shareOpenid) {
      sessionStorage.setItem('shareToken', this.$route.query.shareOpenid)
    }
  },
  mounted: function () {
    if (this.$route.query.pt == 'ckapp') return
    // identity({
    //   callback: function (res) {
    //     if (res.data.code == 200) {
    //       sessionStorage.setItem('is_woolparty', res.data.is_woolparty)
    //     }
    //   }
    // })
    try {
      getlinkidFn()
      let data = {}
      if (sessionStorage.getItem('routefrom')) {
        let routefrom = JSON.parse(sessionStorage.getItem('routefrom'))
        data.scenepoint = routefrom.title
        data.scenedesc = routefrom.link
      } else if (this.$route.query.scenepoint) {
        data.scenepoint = decodeURIComponent(this.$route.query.scenepoint)
      }
      commonburiedPoint({
        data: data
      })
    } catch (e) {}
    if (sessionStorage.getItem('window_scrolltop')) {
      this.$nextTick(() => {
        setTimeout(() => {
          window.scrollTo(
            0,
            parseFloat(sessionStorage.getItem('window_scrolltop'))
          )
        })
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js